module.exports = __webpack_public_path__ + "static/media/lendr.45e319b0.png";